import React from "react";
import { useQuery } from "@tanstack/react-query";
import { WarningOctagon, Lightning } from "@phosphor-icons/react";
import { api, fmtCountdown } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/**
 * NewsBanner — global red banner shown when a HIGH-risk economic event
 * is within 30 minutes. Auto-hides otherwise.
 */
export default function NewsBanner() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["news-banner"],
    queryFn: () => api.get("/news/banner").then((r) => r.data),
    refetchInterval: 30_000,
    enabled: !!user, // don't probe before auth resolves
  });
  const banner = data?.banner;
  if (!banner) return null;
  const mins = Math.max(0, Math.floor((banner.starts_in_seconds || 0) / 60));
  const secs = banner.starts_in_seconds || 0;
  return (
    <div
      data-testid="news-banner"
      className="sticky top-0 z-30 bg-bear/90 border-b border-bear text-white px-5 py-3 backdrop-blur-md flex items-center gap-4 flex-wrap"
    >
      <span className="chip" style={{ background: "rgba(0,0,0,0.35)", borderColor: "rgba(255,255,255,0.2)", color: "#fff" }}>
        <WarningOctagon size={11} weight="fill" /> HIGH RISK
      </span>
      <span className="mono text-sm font-medium">
        {banner.currency} · {banner.name}
      </span>
      {banner.gold_impact && (
        <span className="chip chip-gold">⚡ Gold Impact</span>
      )}
      <span className="ml-auto flex items-center gap-2 mono text-sm">
        <Lightning size={12} weight="fill" />
        {mins > 0 ? `drops in ${mins}m` : `drops in ${fmtCountdown(secs)}`}
      </span>
    </div>
  );
}
